import {
  Component, EventEmitter, Input, OnChanges, Output, SimpleChanges
} from '@angular/core';

import { AppliedToplineItem, AppliedToplines } from 'generated/graphql';

import { isNilOrEmpty } from 'helpers';

import { extractToplines } from '../helpers/extract-toplines';

@Component({
  selector: 'app-toplines-display',
  templateUrl: './toplines-display.component.html',
})
export class ToplinesDisplayComponent implements  OnChanges {
  @Input() appliedToplines: AppliedToplines;

  toplines = [];

  @Input() targetType: 'Entity' | 'EntityConnection';

  @Input() targetId: string;

  @Output() addClick = new EventEmitter<Partial<AppliedToplineItem>>();

  constructor() { }


  ngOnChanges(changes: SimpleChanges): void {
    const appliedTops = changes?.appliedToplines?.currentValue;
    if (!isNilOrEmpty(appliedTops)) {
      this.toplines = this._extractToplines(appliedTops);
    }
  }

  onAddClicked(event) {
    this.addClick.emit(event);
  }

  private _extractToplines(appliedToplines: AppliedToplines) {
    return extractToplines(appliedToplines);
  }
}
